module.exports = __webpack_public_path__ + "static/portrait-1-4db518f05f5503adba2bdd0803e1352e.png";